var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center my-4 w-full h-96 animate-pulse"},[_c('div',{staticClass:"h-full bg-gray-200 w-full rounded"})])
}]

export { render, staticRenderFns }